module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_phone-0a6b358d7ea89a7d6052643ff89c6d14.svg";